<template>
  <div class="input-field-container">
    <!-- 喫煙習慣について -->
    <heading :title="$t('yourLifestyle.smokingHabit')" />
    <!-- 喫煙 -->
    <SmokingQuestion
      v-model="SMK_STAT_TYPE_RSPS_CD"
      @dataInput="dataInput"
      :checkedValue="SMK_STAT_TYPE_RSPS_CD"
    />

    <!-- 禁煙以前の1日の平均喫煙量 -->
    <div class="input-field">
      <hr />
      <input-num
        v-model.number="PAST_DSQTY_RSPS_CD"
        :title="$t('yourLifestyle.averageSmokingAmountInADayBefore')"
        v-validate="
          SMK_STAT_TYPE_RSPS_CD === 2
            ? 'required|between:0.0,100.0'
            : 'between:0.0,100.0'
        "
        :unit="$t('yourLifestyle.ea/day')"
        :disabled="SMK_STAT_TYPE_RSPS_CD !== 2"
        class="inputNum-form"
        name="PAST_DSQTY_RSPS_CD"
        data-vv-as="禁煙以前の1日の平均喫煙量"
      />
    </div>
    <div class="invalid" v-show="errors.has('PAST_DSQTY_RSPS_CD')">
      {{ errors.first("PAST_DSQTY_RSPS_CD") }}
    </div>
    <!-- 禁煙以前の喫煙期間 -->
    <div class="input-field">
      <hr />
      <input-num
        :title="$t('yourLifestyle.smokingPeriodBeforeStopSmoking')"
        v-model.number="PAST_SMK_TERM_RSPS_CD"
        v-validate="
          SMK_STAT_TYPE_RSPS_CD === 2
            ? 'required|between:0.0,100.0'
            : 'between:0.0,100.0'
        "
        :unit="$t('yourLifestyle.year(s)')"
        :disabled="SMK_STAT_TYPE_RSPS_CD !== 2"
        class="inputNum-form"
        name="PAST_SMK_TERM_RSPS_CD"
        data-vv-as="禁煙以前の喫煙期間"
      />
    </div>
    <div class="invalid" v-show="errors.has('PAST_SMK_TERM_RSPS_CD')">
      {{ errors.first("PAST_SMK_TERM_RSPS_CD") }}
    </div>
    <!-- 1日の平均喫煙量 -->
    <div class="input-field">
      <hr />
      <input-num
        v-model.number="CUR_DSQTY_RSPS_CD"
        v-validate="
          SMK_STAT_TYPE_RSPS_CD === 3
            ? 'required|between:0.0,100.0'
            : 'between:0.0,100.0'
        "
        :unit="$t('yourLifestyle.ea/day')"
        :disabled="SMK_STAT_TYPE_RSPS_CD !== 3"
        class="inputNum-form"
        name="CUR_DSQTY_RSPS_CD"
        :title="$t('yourLifestyle.averageSmokingAmountInADay')"
        data-vv-as="1日の平均喫煙量"
      />
    </div>
    <div class="invalid" v-show="errors.has('CUR_DSQTY_RSPS_CD')">
      {{ errors.first("CUR_DSQTY_RSPS_CD") }}
    </div>
    <!-- 喫煙期間 -->
    <div class="input-field">
      <hr />
      <input-num
        :title="$t('yourLifestyle.smokingPeriod')"
        v-model.number="CUR_SMK_TERM_RSPS_CD"
        v-validate="
          SMK_STAT_TYPE_RSPS_CD === 3
            ? 'required|between:0.0,100.0'
            : 'between:0.0,100.0'
        "
        :unit="$t('yourLifestyle.year(s)')"
        :disabled="SMK_STAT_TYPE_RSPS_CD !== 3"
        class="inputNum-form"
        name="CUR_SMK_TERM_RSPS_CD"
        data-vv-as="喫煙期間"
      />
    </div>
    <div class="invalid" v-show="errors.has('CUR_SMK_TERM_RSPS_CD')">
      {{ errors.first("CUR_SMK_TERM_RSPS_CD") }}
    </div>
    <!-- 飲酒習慣について -->
    <heading :title="$t('yourLifestyle.drinking')" class="heading" />
    <!-- 1週間の平均飲酒日数 -->
    <div class="input-field">
      <input-num
        :title="$t('yourLifestyle.averageNumberOfDrinkingDaysInAWeek')"
        v-model.number="DRNK_HABIT_RSPS_CD"
        v-validate="'required|between:0.0,7.0'"
        :unit="$t('yourLifestyle.day(s)')"
        class="inputNum-form"
        name="DRNK_HABIT_RSPS_CD"
        data-vv-as="1週間の平均飲酒日数"
      />
    </div>
    <div class="invalid" v-show="errors.has('DRNK_HABIT_RSPS_CD')">
      {{ errors.first("DRNK_HABIT_RSPS_CD") }}
    </div>
    <!-- 1日の飲酒量 -->
    <div class="input-field">
      <hr />
      <input-num
        :title="$t('yourLifestyle.drinkingAmountInADay')"
        v-model.number="TM1_DRKQTY_RSPS_CD"
        v-validate="'required'"
        :unit="$t('yourLifestyle.cup(s)')"
        class="inputNum-form"
        name="TM1_DRKQTY_RSPS_CD"
        data-vv-as="1日の飲酒量"
      />
    </div>
    <div class="invalid" v-show="errors.has('TM1_DRKQTY_RSPS_CD')">
      {{ errors.first("TM1_DRKQTY_RSPS_CD") }}
    </div>
    <!-- 1週間の平均飲酒量 -->
    <!--TODO 登録名称検討 -->
    <div class="input-field">
      <hr />
      <input-num
        :title="$t('yourLifestyle.averageNumberOfAmountInAWeek')"
        v-model.number="DRNK_QTY_WEK_CD"
        v-validate="'required'"
        :unit="$t('yourLifestyle.cup(s)')"
        class="inputNum-form"
        name="DRNK_QTY_WEK_ID"
        data-vv-as="1週間の平均飲酒量"
      />
    </div>
    <div class="invalid" v-show="errors.has('DRNK_QTY_WEK_ID')">
      {{ errors.first("DRNK_QTY_WEK_ID") }}
    </div>
    <!-- 運動習慣について -->
    <heading :title="$t('yourLifestyle.exercise')" class="heading" />
    <div class="input-field">
      <input-num
        :title="$t('yourLifestyle.numberOfHigh-intensityExerciseNumber')"
        v-model.number="MOV20_WEK_FREQ_ID"
        v-validate="'required|between:0.0,7.0'"
        :unit="$t('yourLifestyle.day(s)')"
        class="inputNum-form"
        name="MOV20_WEK_FREQ_ID"
        data-vv-as="運動週間について"
      />
    </div>
    <div class="invalid" v-show="errors.has('MOV20_WEK_FREQ_ID')">
      {{ $t("validation.requiredText") }}
    </div>
    <div class="input-field">
      <hr />
      <input-num
        :title="$t('yourLifestyle.numberOfMid-intensityExercise')"
        v-model.number="MOV30_WEK_FREQ_ID"
        v-validate="'required|between:0.0,7.0'"
        :unit="$t('yourLifestyle.day(s)')"
        class="inputNum-form"
        name="MOV30_WEK_FREQ_ID"
      />
    </div>
    <div class="invalid" v-show="errors.has('MOV30_WEK_FREQ_ID')">
      {{ $t("validation.requiredText") }}
    </div>
    <div class="input-field">
      <hr />
      <input-num
        :title="$t('yourLifestyle.numberOfWalking')"
        v-model.number="WLK30_WEK_FREQ_ID"
        v-validate="'required|between:0.0,7.0'"
        :unit="$t('yourLifestyle.day(s)')"
        class="inputNum-form"
        name="WLK30_WEK_FREQ_ID"
      />
    </div>
    <div class="invalid" v-show="errors.has('WLK30_WEK_FREQ_ID')">
      {{ $t("validation.requiredText") }}
    </div>
    <next-button
      :label="$t('common.next')"
      :disabled="isDisable"
      @click="clickNextButton"
      class="next-button"
    />
  </div>
</template>

<script>
import Heading from "../../components/atoms/Heading";
import SmokingQuestion from "../../components/molecules/AiDiseasePrediction/SmokingQuestion";
import InputNum from "../../components/molecules/AiDiseasePrediction/InputNum";
import NextButton from "../../components/atoms/NextButton";

export default {
  components: {
    Heading,
    SmokingQuestion,
    InputNum,
    NextButton,
  },
  methods: {
    dataInput: function(val) {
      this.$store.dispatch("aiPrediction/setSMK_STAT_TYPE_RSPS_CD", val);
    },
    clickNextButton() {
      this.$emit("increment");
    },
  },
  computed: {
    // 喫煙習慣
    SMK_STAT_TYPE_RSPS_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setSMK_STAT_TYPE_RSPS_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getSMK_STAT_TYPE_RSPS_CD"];
      },
    },
    // 禁煙以前の1日の平均喫煙量
    PAST_DSQTY_RSPS_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setPAST_DSQTY_RSPS_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getPAST_DSQTY_RSPS_CD"];
      },
    },
    // 禁煙以前の喫煙期間
    PAST_SMK_TERM_RSPS_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setPAST_SMK_TERM_RSPS_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getPAST_SMK_TERM_RSPS_CD"];
      },
    },
    // 1日の平均喫煙量
    CUR_DSQTY_RSPS_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setCUR_DSQTY_RSPS_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getCUR_DSQTY_RSPS_CD"];
      },
    },
    // 喫煙期間
    CUR_SMK_TERM_RSPS_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setCUR_SMK_TERM_RSPS_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getCUR_SMK_TERM_RSPS_CD"];
      },
    },
    // 1週間の平均飲酒日数
    DRNK_HABIT_RSPS_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setDRNK_HABIT_RSPS_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getDRNK_HABIT_RSPS_CD"];
      },
    },
    // 1日の飲酒量
    TM1_DRKQTY_RSPS_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setTM1_DRKQTY_RSPS_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getTM1_DRKQTY_RSPS_CD"];
      },
    },
    // 1週間の平均飲酒量
    // TODO storeとの連携
    DRNK_QTY_WEK_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setDRNK_QTY_WEK_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getDRNK_QTY_WEK_CD"];
      },
    },
    // 激しい運動をした日
    MOV20_WEK_FREQ_ID: {
      set(val) {
        this.$store.dispatch("aiPrediction/setMOV20_WEK_FREQ_ID", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getMOV20_WEK_FREQ_ID"];
      },
    },
    // 中程度の運動をした日
    MOV30_WEK_FREQ_ID: {
      set(val) {
        this.$store.dispatch("aiPrediction/setMOV30_WEK_FREQ_ID", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getMOV30_WEK_FREQ_ID"];
      },
    },
    // 30分歩いた日
    WLK30_WEK_FREQ_ID: {
      set(val) {
        this.$store.dispatch("aiPrediction/setWLK30_WEK_FREQ_ID", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getWLK30_WEK_FREQ_ID"];
      },
    },
    isDisable() {
      let bool = Object.keys(this.fields).some(
        (key) => this.fields[key].invalid
      );
      this.$store.dispatch("validations/setLifeStyle", bool);
      return bool;
    },
  },
  created() {
    //スクロールの位置を初期化；　indexをページトップにする処理
    scrollTo(0, 0);
  },
};
</script>

<style scoped>
.input-field-container {
  width: 100%;
  margin: auto;
}
.input-field {
  margin-top: 20px;
}
.heading {
  margin-top: 40px;
}
.input-field >>> .form-group {
  grid-template-columns: 3fr 0.5fr 0.5fr;
}
.next-button {
  margin-top: 40px;
}
.invalid {
  border-color: red;
  color: red;
  margin-top: 10px;
}
</style>
